import React, { useState, useCallback, useEffect, useMemo } from "react";
import useStyles from "./style";
import {
  Button,
  Typography,
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from "@mui/material";
import {
  EditOutlined,
  DeleteOutline,
  AddOutlined,
  SearchOutlined,
  ChevronLeft,
  ChevronRight,
} from "@mui/icons-material";
import * as XLSX from "xlsx";
import Papa from "papaparse";
import jsPDF from "jspdf";
import "jspdf-autotable";
import { showLoader, hideLoader } from "Redux/Loader/actions";
import { showSnackbar } from "Redux/SnackBar/actions";
import { useDispatch, useSelector } from "react-redux";
import _ from "lodash";

//Services
import servicetypeapi from "Services/Servicefare";

//Modals
import ServicetypeAddModal from "Pages/Modals/Servicetypefare/Create";
import ServicetypeUpdateModal from "Pages/Modals/Servicetypefare/Update";
import ServicetypeDeleteDialog from "Pages/Modals/Servicetypefare/Delete";

const Servicetype = () => {
  const classes = useStyles();
  const dispatch = useDispatch();

  const demoaccount_id = useSelector(
    (state) => state?.AuthReducer?.demoaccount_id || ""
  );

  const [row, setRow] = useState([]);
  const [servicefarerow, servicefaresetRow] = useState([]);
  const [bulkrow, setbulkrow] = useState([]);
  const [customerId, setCustomerId] = useState("");
  const [searchText, setSearchText] = useState("");

  // Pagination
  const [page, setPage] = useState(1);
  const [pageSize] = useState(10);
  const [totalPages, setTotalPages] = useState(1);

  // Modals
  const [addServicetypeModal, setaddServicetypeModal] = useState(false);
  const [updateServicetypeModal, setupdateServicetypeModal] = useState(false);
  const [deleteServicetypeModal, setdeleteServicetypeModal] = useState(false);

  const handleOpenAddServiceModal = () => {
    setaddServicetypeModal(true);
  };

  const handleCloseAddServiceModal = () => {
    setaddServicetypeModal(false);
    getServicetype();
  };

  const handleOpenUpdateServiceModal = (row) => {
    setCustomerId(row?._id);
    setupdateServicetypeModal(true);
  };

  const handleCloseUpdateServiceModal = () => {
    setupdateServicetypeModal(false);
    getServicetype();
  };

  const handleOpenDeleteServiceModal = (row) => {
    setCustomerId(row?._id);
    setdeleteServicetypeModal(true);
  };

  const handleCloseDeleteServiceModal = () => {
    setdeleteServicetypeModal(false);
    getServicetype();
  };

  // Get Services list api
  const getServicetype = useCallback(() => {
    dispatch(showLoader("Loading please wait..."));
    const onSuccess = (res) => {
      dispatch(hideLoader());
      if (res?.data?.status === true) {
        setTotalPages(res?.data?.data?.totalRecords || 1);
        setRow(res?.data?.data?.data);
        servicefaresetRow(res?.data?.data?.serviceFaresdata || []);
      } else {
        setRow([]);
        servicefaresetRow([]);
      }
    };
    const onFailure = (err) => {
      dispatch(hideLoader());
      dispatch(
        showSnackbar({
          message: err?.response?.data?.message || "Failed to fetch data",
          autoHideDuration: 3000,
          anchorOrigin: {
            vertical: "top",
            horizontal: "right",
          },
          variant: "error",
        })
      );
    };
    const params = { page, limit: pageSize, search: "" };
    servicetypeapi.getServicesList(params).then(onSuccess, onFailure);
  }, [page, pageSize, dispatch]);

  const getallservices = useCallback(() => {
    const onSuccess = (res) => {
      if (res?.data?.status === true) {
        setbulkrow(res?.data?.data?.data || []);
      } else {
        setbulkrow([]);
      }
    };
    const onFailure = () => {};
    const params = { page: 1, limit: "unlimited", search: "" };
    servicetypeapi.getServicesList(params).then(onSuccess, onFailure);
  }, []);

  useEffect(() => {
    getServicetype();
    getallservices();
  }, [getServicetype, getallservices]);

const serviceFareStatusMap = useMemo(() => {
  const map = {};

  (servicefarerow || []).forEach((fare) => {
    const serviceTypeId = String(fare?.serviceTypeId);

    const isActive =
      fare?.isActive === 1 ||
      fare?.isActive === true ||
      fare?.isActive === "1";

    // If multiple fare records exist for the same service,
    // keep Active if any matching record is Active
    if (map[serviceTypeId] !== true) {
      map[serviceTypeId] = isActive;
    }
  });

  return map;
}, [servicefarerow]);

  const calculateSno = (pageIndex, pSize, index) => {
    return (pageIndex - 1) * pSize + index + 1;
  };


  const dataRows = useMemo(() => {
  let filteredData = row || [];

  if (searchText.trim()) {
    filteredData = filteredData.filter((item) =>
      item?.serviceName
        ?.toLowerCase()
        .includes(searchText.toLowerCase())
    );
  }

  return _.map(filteredData, (data, index) => {
    const serviceId = String(data?._id);

    return {
      sno: calculateSno(page, pageSize, index),
      serviceImage: data?.serviceImage,
      serviceType: data?.serviceName,

      status:
        serviceFareStatusMap[serviceId] ??
        (
          data?.isActive === 1 ||
          data?.isActive === true ||
          data?.isActive === "1"
        ),

      row: data,
    };
  });
}, [
  row,
  page,
  pageSize,
  serviceFareStatusMap,
  searchText,
]);


  const bulkdataRows = _.map(
    _.orderBy(bulkrow || [], ["createdAt"], ["asc"]),
    (data, index) => ({
     sno: index + 1,
    serviceType: data?.serviceName,
    status:
      serviceFareStatusMap[data?._id] !== undefined
        ? serviceFareStatusMap[data?._id]
          ? "Active"
          : "Inactive"
        : data?.isActive
          ? "Active"
          : "Inactive",
    })
  );

  const formatteddatas = dataRows.map((r) => ({
    "S.NO": r.sno,
    "Service Type": r.serviceType,
    "Status": r.status ? "Active" : "Inactive",
  }));

  const bulkformatteddatas = bulkdataRows.map((r) => ({
    "S.NO": r.sno,
    "Service Type": r.serviceType,
    "Status": r.status,
  }));

  // Export handlers
  const handleDownloadAll = () => {
    const csv = Papa.unparse(bulkformatteddatas);
    const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", "All ServiceFareList.csv");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const handleCopy = () => {
    const header = ["S.NO", "Service Type", "Status"].join("\t");
    const rows = dataRows
      .map((r) => [r.sno, r.serviceType, r.status ? "Active" : "Inactive"].join("\t"))
      .join("\n");
    navigator.clipboard.writeText([header, rows].join("\n")).then(() => {
      alert("Table copied to clipboard!");
    });
  };

  const handleDownloadExcel = () => {
    const worksheet = XLSX.utils.json_to_sheet(formatteddatas);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "ServiceFares");
    XLSX.writeFile(workbook, "ServiceFareList.xlsx");
  };

  const handleDownloadCSV = () => {
    const csv = Papa.unparse(formatteddatas);
    const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", "ServiceFareList.csv");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const handleDownloadPDF = () => {
    const doc = new jsPDF();
    const tableData = dataRows.map((r) => [
      r.sno,
      r.serviceType,
      r.status ? "Active" : "Inactive",
    ]);
    doc.autoTable({
      head: [["S.NO", "Service Type", "Status"]],
      body: tableData,
    });
    doc.save("ServiceFareList.pdf");
  };

  // Pagination
  const totalPagesCount = Math.ceil(totalPages / pageSize) || 1;

  const renderPagination = () => {
    let pages = [];
    const internalPage = page - 1;
    if (totalPagesCount <= 5) {
      for (let i = 0; i < totalPagesCount; i++) pages.push(i);
    } else {
      if (internalPage < 3) {
        pages = [0, 1, 2, "...", totalPagesCount - 1];
      } else if (internalPage > totalPagesCount - 4) {
        pages = [0, "...", totalPagesCount - 3, totalPagesCount - 2, totalPagesCount - 1];
      } else {
        pages = [0, "...", internalPage - 1, internalPage, internalPage + 1, "...", totalPagesCount - 1];
      }
    }

    return pages.map((item, index) => {
      if (item === "...") {
        return (
          <span key={index} className={classes.pageDots}>
            ...
          </span>
        );
      }
      return (
        <Button
          key={item}
          className={internalPage === item ? classes.pageButtonActive : classes.pageButton}
          onClick={() => setPage(item + 1)}
        >
          {item + 1}
        </Button>
      );
    });
  };

  return (
    <Box className={classes.root}>
      {/* Header */}
      <Box className={classes.headerContainer}>
        <Typography className={classes.pageTitle}>Service Type Fares</Typography>
        <Typography className={classes.breadcrumb}>
          Admin / <span>Service Type Fares</span>
        </Typography>
      </Box>

      {/* Action Row */}
      <Box className={classes.actionRow}>
        {/* Search */}
        <Box className={classes.searchWrapper}>
          <SearchOutlined className={classes.searchIcon} />
          <input
            type="text"
            placeholder="Search service type fares..."
            className={classes.searchInput}
            value={searchText}
            onChange={(e) => {
              setSearchText(e.target.value);
              setPage(1);
            }}
          />
        </Box>

        {/* Right Actions */}
        <Box className={classes.rightActions}>
          {!demoaccount_id && (
            <Button
              variant="contained"
              className={classes.addButton}
              onClick={handleOpenAddServiceModal}
              startIcon={<AddOutlined />}
            >
              Add Fare Model
            </Button>
          )}
        </Box>
      </Box>

      {/* Table */}
      <TableContainer component={Paper} elevation={0} className={classes.tableWrapper}>
        <Table>
          <TableHead>
            <TableRow className={classes.tableHeaderRow}>
              <TableCell className={classes.tableHeaderCell}>S.No</TableCell>
              <TableCell className={classes.tableHeaderCell}>Service Image</TableCell>
              <TableCell className={classes.tableHeaderCell}>Service Type</TableCell>
              <TableCell className={classes.tableHeaderCell}>Status</TableCell>
              {!demoaccount_id && (
                <TableCell className={classes.tableHeaderCell} align="right">
                  Actions
                </TableCell>
              )}
            </TableRow>
          </TableHead>
          <TableBody>
            {dataRows.map((rowItem) => (
              <TableRow key={rowItem.sno} className={classes.tableRow}>
                <TableCell className={classes.tableCell}>{rowItem.sno}</TableCell>
                <TableCell className={classes.tableCell}>
                  {rowItem.serviceImage ? (
                    <Box
                      component="img"
                      sx={{
                        width: 44,
                        height: 44,
                        borderRadius: "8px",
                        objectFit: "cover",
                        border: "1px solid #e2e8f0",
                        boxShadow: "0 1px 2px rgba(0,0,0,0.05)",
                      }}
                      src={rowItem.serviceImage}
                      alt={rowItem.serviceType}
                    />
                  ) : (
                    "-"
                  )}
                </TableCell>
                <TableCell className={`${classes.tableCell} ${classes.boldText}`}>
                  {rowItem.serviceType}
                </TableCell>
                <TableCell className={classes.tableCell}>
                  <Box
                    sx={{
                      display: "inline-block",
                      padding: "4px 12px",
                      borderRadius: "100px",
                      fontSize: "12px",
                      fontWeight: "600",
                      textTransform: "capitalize",
                      backgroundColor: rowItem.status ? "#dcfce7" : "#fee2e2",
                      color: rowItem.status ? "#15803d" : "#b91c1c",
                    }}
                  >
                    {rowItem.status ? "Active" : "Inactive"}
                  </Box>
                </TableCell>
                {!demoaccount_id && (
                  <TableCell className={classes.tableCell} align="right">
                    <Box
                      component="span"
                      className={classes.actionButton}
                      onClick={() => handleOpenUpdateServiceModal(rowItem.row)}
                    >
                      <EditOutlined fontSize="small" />
                      Edit
                    </Box>
                    <Box
                      component="span"
                      className={classes.actionDeleteButton}
                      onClick={() => handleOpenDeleteServiceModal(rowItem.row)}
                    >
                      <DeleteOutline fontSize="small" />
                      Delete
                    </Box>
                  </TableCell>
                )}
              </TableRow>
            ))}
            {dataRows.length === 0 && (
              <TableRow>
                <TableCell
                  colSpan={demoaccount_id ? 4 : 5}
                  style={{ textAlign: "center", padding: "40px" }}
                >
                  <Typography variant="body2" color="textSecondary">
                    No service type fares found
                  </Typography>
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>

        {/* Pagination */}
        <Box className={classes.paginationContainer}>
          <Typography className={classes.paginationText}>
            Showing {(page - 1) * pageSize + (dataRows.length > 0 ? 1 : 0)} to{" "}
            {Math.min(page * pageSize, totalPages)} of {totalPages} results
          </Typography>

          <Box className={classes.paginationControls}>
            <ChevronLeft
              className={`${classes.pageArrow} ${page === 1 ? "disabled" : ""}`}
              onClick={() => page > 1 && setPage(page - 1)}
            />
            {renderPagination()}
            <ChevronRight
              className={`${classes.pageArrow} ${page === totalPagesCount ? "disabled" : ""}`}
              onClick={() => page < totalPagesCount && setPage(page + 1)}
            />
          </Box>
        </Box>
      </TableContainer>

      <ServicetypeAddModal
        openDialog={addServicetypeModal}
        handleClose={handleCloseAddServiceModal}
      />
      <ServicetypeUpdateModal
        openDialog={updateServicetypeModal}
        id={customerId}
        handleClose={handleCloseUpdateServiceModal}
      />
      <ServicetypeDeleteDialog
        openDialog={deleteServicetypeModal}
        id={customerId}
        handleClose={handleCloseDeleteServiceModal}
      />
    </Box>
  );
};

export default Servicetype;
